import React from 'react';

import {SimpleSelect, IItem} from '../../../select';

interface TextListProps {
  value: any;
  options: any;
  disabled: boolean;
  onChange: (value: any) => void;
}

const toOptions = (options: any) => {
  /* filter out options if there is no value */
  return options?.map((vo: any): IItem => {
    return {
      label: vo.name || vo.value,
      value: vo.value
    }
  }).filter((vo: any) => !!vo.value) || [];
}

export const TextList = ({
  value,
  options,
  disabled,
  onChange,
}: TextListProps) => {
  const onValueChange = (item: IItem) => {
    onChange(item.value);
  }
  const _options = toOptions(options);

  return (
    <SimpleSelect
      selected={value}
      disabled={disabled || !_options.length}
      onChange={onValueChange}
      options={_options}
      buttonProps={{minimal: false}}
      popoverProps={{usePortal: true}}
    />
  )
};
